module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_307287.d1ea3620.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetInRecargas/FormatoSimplificado_307287.pdf
// module id = 827
// module chunks = 0